import React, { PropTypes, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { icons, positions } from '../icons';
import Translate from '../layout/Translate';

export default class TourRouteMarker extends Component {

    componentDidMount() {
        let zoom = this.props.zoom,
            map = this.props.map,
            markerComponent = this;
        zoom = map.getZoom();

    }
    componentDidUpdate() {
    }
    componentWillUnmount() {

    }


    setZoom(currentZoom, zoom) {
        if (currentZoom < 10) {
            this.props.actions.setMapConfig({zoom: zoom});
        }
    }

    render () {
        let zoom = this.props.zoom,
            map = this.props.map;
            zoom = map.getZoom();


        return (
            <div onClick={this.setZoom.bind(this, zoom, 10)} className={" route-marker marker_" + this.props.text + " " + ((this.props.text == "tent_night" || this.props.text == "text_night" || this.props.text == "hotel_night" || this.props.text == "train_night" || this.props.text == "boat_night")? ((zoom < 6 && !(this.props.map_config.zoom < 7))?"route-marker_hidden":"") + " route-marker_night " + ((zoom < 10)?"route-marker_night_small":""): ((zoom < 7 && !(this.props.map_config.zoom < 7))?"route-marker_hidden":"") + " route-marker_activity " + ((zoom < 10)?"route-marker_activity_small":"")) + "" }
                 style={{position: 'absolute',
                             opacity: this.props.scroll.opacity
                         }
                     }
            >

                <div className={"route-marker__tooltip " + ((zoom < 10)?"route-marker__tooltip_small":"")}>
                    <Translate slug={"map__" + this.props.text} />
                </div>
            </div>



        );
    }
}



// WEBPACK FOOTER //
// ./src/common/components/map/TourRouteMarker.js